import { render } from "./SentEmails.vue?vue&type=template&id=42524c5c&scoped=true"
import script from "./SentEmails.vue?vue&type=script&lang=js"
export * from "./SentEmails.vue?vue&type=script&lang=js"

import "./SentEmails.vue?vue&type=style&index=0&id=42524c5c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42524c5c"]])

export default __exports__